<template>
  <AccountMembersContext
    :key="selectedOrganizationId"
    :account-id="selectedOrganizationId"
    :membership-state="['active']"
    :subject-type="[ACCOUNT_SUBJECT_TYPE.SERVICE_USER]"
    :ui-context="'service'"
  >
    <RouterView />
  </AccountMembersContext>
</template>

<script lang="ts" setup>
import { ACCOUNT_SUBJECT_TYPE } from '@deepcloud/api-deep-admin-backend'
import { useAccountMembershipsContext } from '@/composables/deepadmin/use-account-memberships-context.ts'
import { useAuthorizationContext } from '@/composables/deepadmin/use-authorization-context.ts'
import usePageAccess from '@/composables/deepadmin/use-page-access.ts'
import AccountMembersContext from '@/components/deepadmin/account/AccountMembersContext.vue'

const { selectedOrganizationId } = useAccountMembershipsContext()
const { permissions } = useAuthorizationContext()

definePage({
  meta: {
    breadcrumbLabelKey: 'navigation.organization.users.service',
  },
})

usePageAccess(
  computed(
    () => !permissions.canReadOrganizationMenu || !permissions.canManageUsers,
  ),
)
</script>
